module.exports = __webpack_public_path__ + "public/images/icon-plus.6f00c0e8b0217cf0f5ed3c6b38dd08d1.svg";